export const parseDecimalInput = (input) => {
    if (typeof input !== "string") return "";

    const isValid = /^[0-9]*[.,]?[0-9]*$/.test(input.trim());

    if (!isValid) return null;
    return input.replace(",", ".");
};

export const validateMaterials = (materials) => {
    const invalid = materials.filter((m) =>
        m.name.trim() === "" ||
        m.unit.trim() === "" ||
        isNaN(parseFloat(m.cost)) ||
        parseFloat(m.cost) <= 0
    );

    return {
        isValid: invalid.length === 0,
        invalidCount: invalid.length
    };
};

export const validateExtraWork = (extraWork) => {
    const invalid = extraWork.filter(
        (item) => !item.omschrijving || item.omschrijving.trim() === ""
    );

    return {
        isValid: invalid.length === 0,
        invalidCount: invalid.length
    };
};



export const parseDateInput = (input) => {
    if (typeof input !== "string") return "";

    // Alleen cijfers, streepjes en slashes toegestaan
    const isValid = /^[0-9/-]*$/.test(input.trim());

    if (!isValid) return null;

    // Vervang slashes door streepjes voor consistentie
    return input.replace(/\//g, "-");
};

export const parsePhoneInput = (input) => {
    if (typeof input !== "string") return "";

    // Alleen cijfers, spaties, plustekens en haakjes toegestaan
    const isValid = /^[0-9\s+()]*$/.test(input.trim());

    if (!isValid) return null;

    // Verwijder spaties en haakjes voor consistentie
    return input.replace(/\s+/g, "").replace(/[()]/g, "");
};

export const parseEmailInput = (input) => {
    if (typeof input !== "string") return "";

    // E-mail validatie
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.trim());

    if (!isValid) return null;

    return input.trim();
};

export const parseTextInput = (input) => {
    if (typeof input !== "string") return "";

    // Alleen letters, cijfers, spaties en leestekens toegestaan
    const isValid = /^[a-zA-Z0-9\s.,;:!?'"()-]*$/.test(input.trim());

    if (!isValid) return null;

    return input.trim();
};

export const parseKvKInput = (input) => {
    if (typeof input !== "string") return "";

    // Alleen cijfers toegestaan
    const isValid = /^[0-9]*$/.test(input.trim());

    if (!isValid) return null;

    return input.trim();
};

export const parseVatInput = (input) => {
    if (typeof input !== "string") return "";

    // Alleen letters, cijfers en streepjes toegestaan
    const isValid = /^[A-Z0-9-]*$/.test(input.trim());

    if (!isValid) return null;

    return input.trim();
};

export const parseAddressInput = (input) => {
    if (typeof input !== "string") return "";

    // Alleen letters, cijfers, spaties en leestekens toegestaan
    const isValid = /^[a-zA-Z0-9\s.,;:!?'"()-]*$/.test(input.trim());

    if (!isValid) return null;

    return input.trim();
};